import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Routes } from "@angular/router";
import { DefaultComponent } from "../theme/pages/default/default.component";
import { LiveTrackingComponent } from "./LiveTracking.component";
import { LiveTrackingRoutingModule } from "./LiveTracking-routing.routing";
import { LayoutModule } from "../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { appService } from "../_services/app.service";
import { NgxBarcodeModule } from "ngx-barcode";
import { CommonService } from "../_services/common.service";
import { HttpClient } from "@angular/common/http";
import { RatingModule } from "ngx-bootstrap";
import { TranslateLoader, TranslateModule, TranslateService, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { PrintFormatsModule } from "../print-formats/print-formats.module";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

// const routes: Routes = [
//   {
//     path: "",
//     component: DefaultComponent,
//     children: [
//       {
//         path: "",
//         component: LiveTrackingComponent,
//       },
//     ],
//   },
// ];

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    FormsModule,
    RatingModule,
    LiveTrackingRoutingModule,
    NgxBarcodeModule,
    PrintFormatsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [LiveTrackingComponent],
  declarations: [LiveTrackingComponent],
  providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class LiveTrackingModule { }
